import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';

// Dynamically import the cart components with SSR disabled
const CartIcon = dynamic(() => import('./CartIcon'), {
  ssr: false,
  loading: () => (
    <button className="relative p-2 text-white hover:text-gray-200 transition-colors cursor-pointer">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-6 h-6"
      >
        <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17M17 13v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m8 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01"/>
      </svg>
    </button>
  )
});

const CartDrawer = dynamic(() => import('./CartDrawer'), {
  ssr: false,
  loading: () => null
});

/**
 * Server-side compatible example component showing how to use the CartIcon with CartDrawer
 * This shows the typical pattern for integrating the cart icon into your navigation
 */
export default function CartIconExample() {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const handleOpenCart = () => {
    setIsCartOpen(true);
  };

  const handleCloseCart = () => {
    setIsCartOpen(false);
  };

  // Show loading state during SSR
  if (!isClient) {
    return (
      <button className="relative p-2 text-white hover:text-gray-200 transition-colors cursor-pointer">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-6 h-6"
        >
          <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17M17 13v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m8 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01"/>
        </svg>
      </button>
    );
  }

  return (
    <>
      <CartIcon onClick={handleOpenCart} />
      <CartDrawer isOpen={isCartOpen} onClose={handleCloseCart} />
    </>
  );
}

/**
 * Example of how to integrate the cart icon into your TopBar component:
 * 
 * 1. Import the CartIcon and CartDrawer components:
 *    import { CartIcon, CartDrawer } from '@/src/components/Cart';
 * 
 * 2. Add cart state to your TopBar component:
 *    const [isCartOpen, setIsCartOpen] = useState(false);
 * 
 * 3. Add the CartIcon next to your AccountDropdown:
 *    <div className="md:mr-4 md:flex gap-4">
 *      {buildMenuItems(menuItems)}
 *      <CartIcon onClick={() => setIsCartOpen(true)} />
 *      <AccountDropdown loggedIn={loggedIn} />
 *    </div>
 * 
 * 4. Add the CartDrawer at the end of your TopBar component:
 *    <CartDrawer isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
 */ 